export default "__VITE_ASSET__QQErx9tF__"